import { render, staticRenderFns } from "./LinkWordEdit.vue?vue&type=template&id=f20b68d4&scoped=true&"
import script from "./LinkWordEdit.vue?vue&type=script&lang=js&"
export * from "./LinkWordEdit.vue?vue&type=script&lang=js&"
import style0 from "./LinkWordEdit.vue?vue&type=style&index=0&id=f20b68d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20b68d4",
  null
  
)

export default component.exports